import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import './BetaBanner.css';

const BetaBanner = ({ variant = 'default' }) => {
  return (
    <motion.div 
      className={`beta-banner beta-banner-${variant}`}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.2 }}
    >
      <Sparkles size={14} className="beta-icon" />
      <span className="beta-text">BETA</span>
    </motion.div>
  );
};

export default BetaBanner;
